import * as React from 'react';
import { ProductBlocksContainer } from '@grandvisionhq/products';
import { useFeatureToggles } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachSiteLogos } from '../../hooks/use-bloomreach-site-logos.js';
import '../../hooks/use-breakpoint-visibility.js';
import { ProductListingRow } from './ProductListingRow.js';

const ProductListingRowWrapper = ({ skus , limit  })=>{
    const { isRestructuredProductBlockEnabled  } = useFeatureToggles();
    const siteLogos = useBloomreachSiteLogos();
    if (!isDefined(skus) || skus.length === 0) {
        return null;
    }
    if (isRestructuredProductBlockEnabled) {
        return /*#__PURE__*/ React.createElement(ProductListingRow, {
            skus: skus.slice(0, 2)
        });
    }
    return /*#__PURE__*/ React.createElement(ProductBlocksContainer, {
        skus: skus.length > 6 ? skus.slice(0, 6) : skus,
        limit: limit,
        reimbursableLogos: {
            default: siteLogos.reimbursable,
            alternative: siteLogos.reimbursableAlternative
        }
    });
};

export { ProductListingRowWrapper };
//# sourceMappingURL=ProductListingRowWrapper.js.map
